/* eslint-disable react/no-array-index-key */
import React, { useContext, useState } from 'react';
import Button from '@material-ui/core/Button';
import {
  HCPCSGlobalContext,
  GlobalContext,
  SET_SHOW_HCPCS,
  RESET_HCPCS,
  SHOW_HCPCS_LOADER,
} from '@mummssoftware/global-context';
import {
  buildHCPCS,
  addDuration,
  icdCodeNamesToMap,
} from '@mummssoftware/utils/hcpcsUtils';
import { error } from '@mummssoftware/utils/constants';
import { ConfirmHCPCSDialog } from './ConfirmHCPCSDialog';
import { AppContext } from '../../../../context';
import { updateVisitHCPCS } from '../../../Context/visitLogUtils';
import { SET_API_ERROR, ADD_DETAILS } from '../../../Context/constants';
import { VisitLogContext } from '../../../Context/VisitLogContext';
import { SubmitHCPCSDiv } from './HCPCSWrapper';
import defaults from '../../../../translations/en.json';

export const SubmitHCPCS = () => {
  const {
    submithcpcsError,
    hcpcsError,
    dispatchHCPCS,
    hcpcsCodesMap,
    icdCodeNames,
    recordData,
    hcpcsDuration,
  } = useContext(HCPCSGlobalContext);
  const { editingPastVisit } = useContext(GlobalContext);

  const { currentUser, agency, patient, pim, keycloak } = useContext(
    AppContext,
  );
  const [open, setOpen] = useState<boolean>(false);
  const { dispatch } = useContext(VisitLogContext);
  const confirmHCPCS = () => {
    setOpen(true);
  };

  const confirmCancel = () => {
    setOpen(false);
    cancelHCPCS();
  };

  const recordHCPCS = async () => {
    setOpen(false);

    if (patient && currentUser) {
      if (hcpcsDuration && editingPastVisit) {
        const hcpcsallduration = addDuration(Object.values(hcpcsDuration));
        if (
          hcpcsallduration > (editingPastVisit as mumms.PatientVisit).duration
        ) {
          (editingPastVisit as mumms.PatientVisit).duration = hcpcsallduration;
        }
      }

      dispatchHCPCS({
        type: SHOW_HCPCS_LOADER,
        payload: true,
      });
      const hcpcs: any = buildHCPCS(
        hcpcsCodesMap,
        hcpcsDuration,
        icdCodeNamesToMap(icdCodeNames),
        patient?.currentFacilityId,
        patient?.currentFacilityType,
      );
      const updatedVisit = await updateVisitHCPCS(
        pim,
        patient.patientNumber,
        currentUser?.personNumber as string,
        editingPastVisit,
        agency,
        keycloak,
        hcpcs,
      );

      if (!updatedVisit) {
        dispatch({
          type: SET_API_ERROR,
          payload: {
            text: defaults.pimFailed,
            severity: error,
          },
        });
      } else if (updatedVisit && updatedVisit[0]) {
        dispatch({
          type: ADD_DETAILS,
          payload: updatedVisit[0],
        });
      }
      dispatchHCPCS({
        type: SHOW_HCPCS_LOADER,
        payload: false,
      });
      dispatchHCPCS({
        type: SET_SHOW_HCPCS,
        payload: false,
      });
      dispatchHCPCS({
        type: RESET_HCPCS,
      });
    }
  };

  const cancelHCPCS = () => {
    dispatchHCPCS({
      type: SET_SHOW_HCPCS,
      payload: false,
    });
    dispatchHCPCS({
      type: RESET_HCPCS,
    });
  };

  return (
    <SubmitHCPCSDiv record>
      <ConfirmHCPCSDialog
        open={open}
        onRecord={recordHCPCS}
        onCancel={cancelHCPCS}
      />
      <Button
        title={defaults.cancel}
        size="small"
        variant="contained"
        color="primary"
        onClick={confirmCancel}
      >
        {defaults.cancel}
      </Button>
      <Button
        title={defaults.recordHCPCS}
        size="small"
        variant="contained"
        color="primary"
        onClick={confirmHCPCS}
        disabled={submithcpcsError || !!hcpcsError || !recordData}
      >
        {defaults.recordHCPCS}
      </Button>
    </SubmitHCPCSDiv>
  );
};
